import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import {
    Box,
    Container,
    Card,
    Button,
    TextField,
    Divider,
    InputLabel,
    Select,
    Alert,
    Checkbox,
    FormControlLabel,
    CircularProgress,
    Typography,
    CardHeader,
    CardContent
} from '@material-ui/core';
import { useGet, usePut } from '../../../API/request';
import { BallTriangle } from 'react-loader-spinner';

const Prodamus = () => {

    const getU = useGet();
    const putU = usePut();

    const [isLoaded, setIsLoaded] = useState(true);
    const [submitDisabled, setSubmitDisabled] = useState(false);

    const [values, setValues] = useState({
        secretKey: '',
        paymentLink: '',
    });

    const [alert, setAlert] = useState({
        txt: '',
        isVisible: false,
        type: 'error'
    });

    const showAlert = (type, text) => {
        setAlert({
            txt: text,
            type,
            isVisible: true
        });

        setTimeout(() => {
            setAlert({
                txt: text,
                type,
                isVisible: false
            });

            setSubmitDisabled(false);
        }, 1400);
    };


    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };

    const submit = () => {
        setSubmitDisabled(true);

        const data = {
            key: values.secretKey,
            link: values.paymentLink
        }

        putU('prodamus', data)
            .then((response) => {
                if (response.status === 'success') {
                    showAlert('success', 'Вы успешно обновили данные Prodamus');
                } else {
                    showAlert('error', 'Произошла ошибка при попытке обновить данные Prodamus');
                }
            })
            .catch((e) => {
                showAlert('error', e?.response?.data?.message);
            })
            .finally(() => {
                setSubmitDisabled(false);
            });
    };


    useEffect(() => {
        setIsLoaded(true);
        getU('prodamus')
            .then((response) => {
                if (response.status === 'success') {
                    setValues({
                        secretKey: response.data.secretKey,
                        paymentLink: response.data.paymentLink
                    });
                } else {
                    showAlert('error', 'Произошла ошибка при попытке получить данные Prodamus');
                }
            })
            .catch((e) => {
                showAlert('error', e?.response?.data?.message);
            })
            .finally(() => {
                setIsLoaded(false);
            });
    }, []);

    if (isLoaded) {
        return (
            <div className="loader">
                <BallTriangle
                    height="100"
                    width="100"
                    color='grey'
                    ariaLabel='loading'
                />
            </div>
        );
    }


    return (
        <>
            <Helmet>
                <title>Prodamus</title>
            </Helmet>
            <Box sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 3 }}>
                <Container maxWidth={false}>
                    <Card>
                        <CardHeader title="Конфигурация Prodamus"/>
                        <Divider/>
                        <CardContent sx={{ position: 'relative' }}>
                            <TextField
                                fullWidth
                                label="Ключь Prodamus"
                                margin="normal"
                                name="secretKey"
                                onChange={handleChange}
                                type="text"
                                value={values.secretKey}
                                variant="outlined"
                            />
                            <TextField
                                fullWidth
                                label="Ссылка Prodamus"
                                margin="normal"
                                name="paymentLink"
                                onChange={handleChange}
                                type="text"
                                value={values.paymentLink}
                                variant="outlined"
                            />
                            <Alert severity={alert.type}
                                   style={{ display: alert.isVisible ? 'flex' : 'none' }}>
                                {alert.txt}
                            </Alert>
                        </CardContent>
                        <Divider/>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={submit}
                                disabled={submitDisabled}
                            >
                                Сохранить
                            </Button>
                        </Box>
                    </Card>
                </Container>
            </Box>
        </>
    );
};

export default Prodamus;
